<h1 mat-dialog-title>Privacy Notice</h1>
<div mat-dialog-content class="mat-typography">
    <p>
        I have been informed, and made aware, of the purpose(s) for collecting my personal information as described in the 
        <a href="privacy-policy" target="_blank">Terms of Service and Privacy Policy</a>. 
        All processed is for BalikBayanBox OFW Portal.
    </p>
    <p>All private data (name, contact number, and e-mail) I have given shall be treated with confidentiality and used exclusively for marketing purposes.</p>
    <p>By providing my personal information, I consent to the use, processing, storage, transfer, and disclosure of my personal information as described above.</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">
        {{ 'LABEL_CANCEL' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>
        {{ 'I_AGGREE' | translate }}
    </button>
</div>